<mat-form-field appearance="outline" [floatLabel]="floatLabel">
    <mat-label>
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>

    <textarea
        #input
        matInput
        rows="1"
        [placeholder]="placeholder"
        autocomplete="nothing"
        [formControl]="aumFormControl"
    ></textarea>
    <mat-icon
        matSuffix
        *ngIf="aumFormControl!=null && aumFormControl.invalid && aumFormControl.touched"
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>
    <mat-error *ngIf="aumFormControl && aumFormControl.invalid">
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
